import { TextSortBy } from "nystem-components";

const FloatSortBy = (props) => <TextSortBy {...props} />;
export default FloatSortBy;
